import { render, staticRenderFns } from "./StackLearningUnitSelector.vue?vue&type=template&id=f52171ec&"
import script from "./StackLearningUnitSelector.vue?vue&type=script&lang=js&"
export * from "./StackLearningUnitSelector.vue?vue&type=script&lang=js&"
import style0 from "./StackLearningUnitSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports